export default __webpack_public_path__ + "static/media/pattern-lines.d6471bac.svg";